export function normalizeMarkdownValue(value: unknown): string | null {
  if (value == null) {
    return null;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) {
      return "";
    }

    if (trimmed.startsWith("{") || trimmed.startsWith("[")) {
      try {
        const parsed = JSON.parse(trimmed);
        const parsedContent = extractMarkdownField(parsed);
        if (typeof parsedContent === "string") {
          return parsedContent;
        }
      } catch {
        // Ignore JSON parse errors and fall back to the original string
      }
    }

    return value;
  }

  if (typeof value === "object") {
    const parsedContent = extractMarkdownField(value as Record<string, unknown>);
    if (typeof parsedContent === "string") {
      return parsedContent;
    }
  }

  return null;
}

export function hasMarkdownValue(value: unknown): boolean {
  const normalized = normalizeMarkdownValue(value);
  if (normalized == null) {
    return false;
  }
  return normalized.trim().length > 0;
}

function extractMarkdownField(payload: Record<string, unknown>): unknown {
  if (!payload) {
    return null;
  }

  if (typeof payload.markdown_content === "string") {
    return payload.markdown_content;
  }

  if (typeof payload.content === "string") {
    return payload.content;
  }

  return null;
}
